module.exports = __webpack_public_path__ + "media/images/riders/small/FABIAN_GIGER-ef1b5f4a0241379c1bfe7de5923b0b95.png";